import { type SuretyAccountId } from "@inrev/common";
import { useAccountAttachmentActions } from "@portal/api/attachments";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { type FC, useMemo } from "react";
import type { UploadedDocumentRow } from "../../uploaded-documents/types";
import type { WipReviewQueueColumnsConfig } from "./WipReviewQueueColumns";
import { WipReviewQueueTable } from "./WipReviewQueueTable";
import type { WipReviewQueueRow } from "./wipReviewQueueRow";

const noopDeleteAttachment = (_attachmentId: string) => {
	window.alert(`mock delete attachment: ${_attachmentId}`);
};

const noopTriggerExtraction = (_row: UploadedDocumentRow) => {
	window.alert(`mock trigger extraction: ${_row.file.name}`);
};

const noopRowClick = (_row: WipReviewQueueRow) => {
	window.alert(_row.attachment.file.name);
};

const FIXTURE_RETRY_CONFIG = {
	onTriggerExtraction: noopTriggerExtraction,
	extractionPending: false,
} as const;

const EMPTY_WIP_REVIEW_QUEUE_ROWS: WipReviewQueueRow[] = [];

export type WipReviewPanelProps = {
	accountId: SuretyAccountId;
};

export const WipReviewPanel: FC<WipReviewPanelProps> = ({ accountId }) => {
	const { isAdmin } = useAuthenticatedUser();
	const attachmentActions = useAccountAttachmentActions({
		accountId,
		isAdmin,
	});

	const columnConfig = useMemo((): WipReviewQueueColumnsConfig => {
		return {
			actions: {
				downloadBaseUrl: attachmentActions.downloadBaseUrl,
				downloadQueryKeyPrefix: attachmentActions.downloadQueryKeyPrefix,
				allowDelete: attachmentActions.allowDelete,
				onDeleteAttachment: noopDeleteAttachment,
				deletingAttachmentId: attachmentActions.deletingAttachmentId,
				analyticsContext: "wip-statements",
			},
			retryConfig: FIXTURE_RETRY_CONFIG,
		};
	}, [
		attachmentActions.deletingAttachmentId,
		attachmentActions.downloadBaseUrl,
		attachmentActions.downloadQueryKeyPrefix,
	]);

	return (
		<div className="flex flex-1 min-h-0 flex-col" data-testid="wip-review-panel">
			<WipReviewQueueTable
				data={EMPTY_WIP_REVIEW_QUEUE_ROWS}
				columnConfig={columnConfig}
				onRowClick={noopRowClick}
			/>
		</div>
	);
};
